<div class="login-layout">
  <div class="login-title">
    <div>
      <img src="../../assets/images/logo.svg" />
    </div>
    <div class="title">
      {{appConfig.title}}
    </div>
  </div>
  <form nz-form [formGroup]="loginFormGroup" class="login-form" (ngSubmit)="login()">
    <nz-form-item>
      <nz-form-control>
        <nz-input-group nzPrefixIcon="user">
          <input type="text" nz-input formControlName="account_code" placeholder="用户名" autocomplete='username' />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <nz-input-group nzPrefixIcon="lock">
          <input type="password" nz-input formControlName="account_password" placeholder="密码" autocomplete='password' />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <div *ngIf="error" class="error">
      {{error}}
    </div>
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzBlock [nzType]="'primary'">
          <i nz-icon nzType="enter"></i>
          登录
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
